import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=56eebd0a&"
import script from "./Country.vue?vue&type=script&lang=ts&"
export * from "./Country.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports